import React from 'react';
import BaseComponent from '../../../../baseClasses/BaseComponent';
import UserAvatarWithName from '../../../../components/UserAvatar/UserAvatarWithName';
import ExpandableSection from '../../../../components/ExpandableSectionSettings';
import teamIcon from '../../../../assets/images/teams-icon-blue.svg';
import './SelectMemberList.scss';
import Input from '../../../../components/Input';

class SelectMemberList extends BaseComponent {

  constructor(props) {
    super(props);

    this.state = {
      members: null,
      membersCopy: null,
      searchString: '',
    };

    this.handleSearchMembers = this.handleSearchMembers.bind(this);
  }

  handleSelectMember(member) {
    if (this.props.selectMember) {
      this.props.selectMember(member);
    }
  }

  handleClearSearchBar(){
    var { searchString } = this.state;
    if(searchString != '') {
      this.setState({ members: this.props.members, searchString: '' });
    }
  }

  handleSearchMembers(e) {
    let query;
    query = e.target.value;
    //const queryArray = query.split(" ", 3)
    if (query != '') {
      var { membersCopy } = this.state;
      const newMembers = membersCopy.filter(m => {
        m.full_name = m.first_name + ' ' +  m.last_name;
        m.full_name_reverse = m.last_name + ' ' +   m.first_name;
        if (query == '') {
          return m;
        }
        return m.full_name.toLowerCase().includes(query.toLowerCase()) || m.full_name_reverse.toLowerCase().includes(query.toLowerCase());
      });
      this.setState({ members: newMembers, searchString: query });
      this.forceUpdate();
    }
    else {
      this.setState({ members: this.props.members, searchString: query });
    }
  }

  componentWillReceiveProps(newProps) {
    this.setState({
      membersCopy: newProps.members,
      members: newProps.members,
      
    });
  }

  shouldComponentUpdate(nextProps) {
    return this.state.members != nextProps.members;
  }

  render() {

    let style = {};
    if (this.props.height) {
      style.height = this.props.height;
    }

    let caption = null;
    if (this.props.caption) {
      caption = <div className="member-list-caption">{this.props.caption}</div>;
    }
    
    return(
      <div className="select-member-list" >
        {caption}
        <div className="select-member-scroller" style={style}>
          <div className="select-member-container">
            {this.props.type == 'available' ? <div className='members-search-box'>
              <Input value={this.state.searchString} placeholder='Search Available Users' className='members-search-input' type="text" onChange={this.handleSearchMembers} />
            </div> : null}
            
            {!this.state.members ? <p>No members selected</p> : this.state.members.map((member) => {
              const key = (member.first_name ? 'user_' : 'team_') + member.id;
              const teamMembers = member.first_name ? null : member.users.map((user) => {
                return (
                  <UserAvatarWithName key={user.id} user={user} />
                );
              });
              return <div key={key} className={'member-entry' + (member.first_name ? '' : '-team')}>
                {member.first_name &&
                  <UserAvatarWithName key={member.id} user={member} onClear={this.handleClearSearchBar} selectUser={this.handleSelectMember} />
                }
                
                {!member.first_name &&
                  <ExpandableSection
                    initiallyExpanded={false}
                    name={member.name}
                    animateExpand={this.props.animateExpand}
                    icon={member.logo || teamIcon}
                    onClick={this.handleSelectMember}
                    onClickData={member}
                  >
                    <div className="team-teams-members">
                      {teamMembers}
                    </div>
                  </ExpandableSection>
                }
              </div>;
            })}

            { this.props.type == 'available' ? !this.state.members ||  this.state.members.length == 0  ?
                <p>No Users Found...</p> : null : null
              }
          </div>
        </div>
      </div >
    );
  }
}

export default SelectMemberList;



// WEBPACK FOOTER //
// ./src/containers/PORContainer/EmailUserSelectionPopup/SelectMemberList/index.js